import type { RfqSubmission, SupplierOrg } from '../types';

export const OTHER_QUOTE_VENDOR_ORG_PREFIX = 'other:';

/** Stable synthetic org id for non-portal vendors (hardware, freight, etc.). */
export function otherQuoteVendorOrgId(vendorName: string): string {
  const slug = vendorName
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 48);
  if (!slug) throw new Error('Enter a supplier name.');
  return `${OTHER_QUOTE_VENDOR_ORG_PREFIX}${slug}`;
}

export function isOtherQuoteExternalVendorOrgId(orgId: string): boolean {
  return orgId.startsWith(OTHER_QUOTE_VENDOR_ORG_PREFIX);
}

/** Human-readable fallback when only the synthetic org id is stored. */
export function otherQuoteVendorNameFromOrgId(orgId: string): string | undefined {
  if (!isOtherQuoteExternalVendorOrgId(orgId)) return undefined;
  const slug = orgId.slice(OTHER_QUOTE_VENDOR_ORG_PREFIX.length);
  if (!slug) return undefined;
  return slug
    .split('-')
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');
}

export function resolveOtherQuoteSupplierName(
  sub: Pick<RfqSubmission, 'supplierOrgName'>,
  orgId: string,
  supplierOrgById: Map<string, SupplierOrg>,
): string {
  return (
    sub.supplierOrgName?.trim()
    || supplierOrgById.get(orgId)?.name?.trim()
    || otherQuoteVendorNameFromOrgId(orgId)
    || orgId
  );
}
